// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2eM1T","inputDescription":"styles_inputDescription__3R86S"};